export const LIST_IMPORTZIPS_REQUESTED = 'LIST_IMPORTZIPS_REQUESTED';
export const LIST_IMPORTZIPS_COMPLETED = 'LIST_IMPORTZIPS_COMPLETED';
export const LIST_IMPORTZIPS_FAILED = 'LIST_IMPORTZIPS_FAILED';
